import { isAuthenticated } from '../utils/auth';

export const Auth = () => {
    // const [message, setMessage] = useState<string>('');
    // const [error, setError] = useState<string>('');

    if (!isAuthenticated()) {
        window.location.assign('http://lb.ava.me/api/auth');
    }
    
    return <h1>Not Found</h1>;
};
